import React from 'react';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import UserPickerEdit from '@atlassian/jira-issue-field-base-user-picker/src/ui/edit/index.tsx';
import { FieldContainer } from '../../common/ui/fields/styled.tsx';
import { withFormField } from '../../common/ui/with-form-field/index.tsx';
import { validateUserPickerField } from '../../common/utils/validators/index.tsx';
import type {
	FieldValue,
	Props,
	RespondersFieldConfig,
	ResponderType,
	UserOption,
} from './types.tsx';
import { transformDefaultUserValues } from './utils.tsx';

const RespondersField = (props: Props) => {
	const {
		width,
		fieldProps: { value, onChange, ...fieldProps },
		autoFocus = false,
		fieldId,
		autoCompleteUrl = '',
		placeholder = '',
		isDisabled = false,
	} = props;

	const onFetchSuggestions = async (query: string | null): Promise<UserOption[]> => {
		let responders: ResponderType[] = [];
		if (autoCompleteUrl !== undefined) {
			let autoCompleteResponse: { responders: ResponderType[] };
			try {
				autoCompleteResponse = await performGetRequest(`${autoCompleteUrl}/?query=${query || ''}`);
			} catch (err) {
				return [];
			}
			if (autoCompleteResponse.responders) {
				responders = autoCompleteResponse.responders;
			}
		}
		return transformDefaultUserValues(responders);
	};

	return (
		<FieldContainer width={width}>
			<UserPickerEdit
				{...fieldProps}
				autoCompleteUrl={autoCompleteUrl}
				placeholder={placeholder}
				isDisabled={isDisabled}
				onChange={onChange}
				value={value}
				appearance="normal"
				isMulti
				autoFocus={autoFocus}
				fieldId={fieldId}
				fetchSuggestions={onFetchSuggestions}
				isClearable
			/>
		</FieldContainer>
	);
};

export default withFormField({
	validator: validateUserPickerField,
	transformDefaultValue: transformDefaultUserValues,
	// @ts-expect-error TS2345: Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<RespondersFieldConfig, LegacyValue<UserOption>>, any>'.
})<RespondersFieldConfig, FieldValue>(RespondersField);
